
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DigitalLibraryService } from 'app/infrastructure/services/digitalLibrary.service';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { DigitalLibraryProgressComponent } from '../progress/digital-library-progress.component';
import { NgbModalOptions, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ProductsParametrization } from 'app/infrastructure/model/interfaces/itemLibrary.interface';

@Component({
    selector: 'app-desktop',
    templateUrl: './digital-library-import.component.html'
})
export class DigitalLibraryImportComponent implements OnInit {
    @Input() systemCode: string;
    @Input() channelCode: string;
    @Input() itemId: string;

    parametrization: ProductsParametrization = {
        newCode: '',
        originalCode: ''
    };

    subscriptions = [];

    constructor(
        private aRoute: ActivatedRoute,
        public digitalLibraryService: DigitalLibraryService,
        private alertService: AlertService,
        private router: Router,
        private modalService: NgbModal) { }

    ngOnInit() {
        this.systemCode = this.aRoute.snapshot.params.codsistema;
        this.channelCode = this.aRoute.snapshot.params.codnegocio;
        this.itemId = this.aRoute.snapshot.params.itemid; 

        this.digitalLibraryService
            .getTemplate(this.systemCode, this.channelCode, this.itemId)
            .subscribe(request => {
                this.parametrization = request.parametrization;
                this.subscriptions = request.subscriptions;
            });
    }

    requestTemplate() {
        this.digitalLibraryService.requestTemplate(this.systemCode, this.channelCode, this.itemId, this.parametrization).subscribe(
            transactionId => {
                let modal: NgbModalRef = null;
                const progressModal = DigitalLibraryProgressComponent;
                const ngbModalOptions: NgbModalOptions = {
                    backdrop: 'static',
                    keyboard: false,
                };

                modal = this.modalService.open(progressModal, ngbModalOptions);
                modal.componentInstance.systemCode = this.systemCode;
                modal.componentInstance.businessCode = this.channelCode;
                modal.componentInstance.transactionId = transactionId;
            });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/digital-library/import/digital-library-import.component.ts